import { Box, CircularProgress } from '@mui/material';

interface LoaderProps {
  size?: number;
  fullScreen?: boolean;
  minHeight?: string | number;
}

const Loader: React.FC<LoaderProps> = ({ size = 60, fullScreen = false, minHeight = '400px' }) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <CircularProgress
          size={size}
          sx={{
            color: '#6871d1',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: minHeight,
      }}
    >
      <CircularProgress
        size={size}
        sx={{
          color: '#6871d1',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
      />
    </Box>
  );
};

export default Loader;
